import axios from "axios";

const login = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;

  return true;
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  delete axios.defaults.headers.common["Authorization"];

  return true;
};

export const userService = {
  login,
  logout
};


